export const UsersActionTypes={
    SET_USERS: 'SET_USERS',
    SET_REFRESH_CAPTCHA: 'SET_REFRESH_CAPTCHA',
    SET_VALIDATE_SIGNUP: 'SET_VALIDATE_SIGNUP',
    SET_CONTENT_DATA: 'SET_CONTENT_DATA',
    SET_MATCHED_LANGUAGE_DATA: 'SET_MATCHED_LANGUAGE_DATA'
}